import type { Network } from "@tento-lona/network";

/**
 * How a task's wire fields show on the task surfaces (the task row, the
 * Tasks panel, an app's task table): the color and sort rank of its
 * `importance` and its `status`, keyed by the wire's own values
 * (`Network.TaskPriority`, `Network.TaskStatus`).
 */
export namespace TaskPresentation {
  /** The color of an importance: `high` red, `medium` orange, `low` yellow. */
  export function importanceColor(importance: Network.TaskPriority): string {
    switch (importance) {
      case "low":
        return "var(--yellow-dimmed)";
      case "medium":
        return "var(--orange-dimmed)";
      case "high":
        return "var(--red-dimmed)";
    }
  }

  /** The color of a status. */
  export function statusColor(status: Network.TaskStatus): string {
    switch (status) {
      case "completed":
        return "var(--green-dimmed)";
      case "inProgress":
        return "var(--orange-dimmed)";
      case "planned":
        return "var(--yellow-dimmed)";
      case "autoScheduled":
        return "var(--purple-dimmed)";
    }
  }

  /** An importance's sort rank, most important first: `high` 1, `medium` 2, `low` 3. */
  export function importanceRank(importance: Network.TaskPriority): number {
    switch (importance) {
      case "high":
        return 1;
      case "medium":
        return 2;
      case "low":
        return 3;
    }
  }

  /** A status's sort rank: `autoScheduled` 1, `planned` 2, `inProgress` 3, `completed` 4. */
  export function statusRank(status: Network.TaskStatus): number {
    switch (status) {
      case "autoScheduled":
        return 1;
      case "planned":
        return 2;
      case "inProgress":
        return 3;
      case "completed":
        return 4;
    }
  }
}
